const menuList = [
    {
        name: '招标',
        children: [
            {
                name: '招标代理',
                children: [
                    {name: '《招标代理服务规范》解读'},
                    {name: '五个标准招标文件解读'},
                    {name: '招标人员能力评价学习包'},
                    {name: '招采人员能力评价'},
                ]
            },
            {
                name: '政府与社会资本合作',
                children: [
                    {name: 'PPP政策解读与运作指南'},
                    {name: 'PPP项目管理及采购要点'},
                ]
            },
            {
                name: '国有企业招标采购',
                children: [
                    {name: '采购人法律风险解析与防控'},
                    {name: '风险控制与热点问题解析系列课程'},
                    {name: '国有企业招标采购操作实务'},
                    {name: '国有企业招标采购专业实务及案例分析'},
                ]
            },
            {
                name: '招标进阶',
                children: [
                    {name: '招标采购进阶能力提升课程'},
                    {name: '非招标方式采购操作及采购与供应中的谈判技巧'},
                    {name: '监督管理与审计要点解析培训班'},
                    {name: '国有企业招标采购专业实务及案例分析'},
                ]
            },
        ]
    },
    {
        name: '采购',
        children: [
            {
                name: '政府采购类',
                children: [
                    {name: '政府采购案例分析'},
                    {name: '《政府采购货物和服务招标投标管理办法》'},
                    {name: '《政府采购信息发布管理办法》解读'},
                    {name: '政府采购质疑投诉处理与应对'},
                    {name: '政府采购全流程管理讲解'},
                ]
            },
            {
                name: '采招知道',
                children: [
                    {name: '《非招标方式采购文件示范文本》解读'},
                    {name: '采购文件编制攻略'},
                    {name: '供应商参加政府采购活动的关注要点'},
                    {name: '《招标公告和公示信息发布管理办法》'},
                    {name: '供应商参加政府采购活动的关注要点'},
                ]
            },
            {
                name: '国有企业招标采购',
                children: [
                    {name: '采购人法律风险解析与防控'},
                    {name: '风险控制与热点问题解析系列课程'},
                    {name: '国有企业招标采购操作实务'},
                    {name: '国有企业招标采购专业实务及案例分析'},
                ]
            },
            {
                name: '采招人员能力评价',
                children: [
                    {name: '招采人员能力评价（初级）晋级助力包'},
                    {name: '招采人员能力评价（初级）晋级学习包'},
                    {name: '招采人员能力评价（初级）科目一晋级冲刺包'},
                    {name: '招采人员能力评价（初级）科目二晋级冲刺包'},
                    {name: '招采人员能力评价（中级）科目三强化学习包'},
                ]
            },
        ]
    },
    {
        name: '工程',
        children: [
            {
                name: '建设工程',
                children: [
                    {name: '建设工程合同纠纷案件审理实务'},
                    {name: '必须招标的工程项目规定'},
                    {name: '公路工程建设项目招标投标管理办法解读'},
                    {name: '招标采购合同管理与风险防范'},
                    {name: '工程量清单计价模式下的招投标问题与对策'},
                    {name: '工程总承包招投标常见问题及案例分析'},
                ]
            },
            {
                name: '评标',
                children: [
                    {name: '评标标准和方法的择优即案例分析'},
                    {name: '开标、评标与定标的组织及实务操作'},
                    {name: '施工标评审实务'},
                    {name: '评标专家基础知识'},
                ]
            },
            {
                name: '投标',
                children: [
                    {name: '投标文件受理条件及案例分析'},
                    {name: '招标采购活动中的异议、投诉及案例分析'},
                    {name: '投标能手进阶课程包'},
                    {name: '提高中标率的八种技能'},
                ]
            },
        ]
    },
    {
        name: '其他',
        children: [
            {
                name: '国有产权交易',
                children: [
                    {name: '国有资产管理'},
                    {name: '产权交易与实务'},
                    {name: '国民经济管理'},
                ]
            },
            {
                name: '海洋资源交易',
                children: [
                    {name: '海域使用权出让'},
                    {name: '无居民海岛等海洋资源使用权出让'},
                ]
            },
            {
                name: '林权交易',
                children: [
                    {name: '国有林地使用权，租赁权和林木所有权出让'},
                    {name: '集体统一经营管理的林地经营权和林木所有权出让'},
                ]
            },
            {
                name: '农村集体产权交易',
                children: [
                    {name: '农村集体土地经营权流转'},
                    {name: '农村集体经营性资产出租'},
                    {name: '农村集体资产股权转让'},
                    {name: '四荒（荒山，荒沟，荒丘，荒滩）地使用权流转'},
                ]
            },
            {
                name: '无形资产交易',
                children: [
                    {name: '基础设施和公共事业特许经营权授予'},
                    {name: '市政公用设施及公共场地使用权，承包经营权'},
                ]
            },
            {
                name: '碳排污权交易',
                children: [
                    {name: '定额出让排污权'},
                    {name: '公开拍卖排污权'},
                ]
            },
        ]
    },
]
 
export default menuList